import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'lib-bouncing-loader',
  template: `
    <div class="text-center py-8">
      <div class="flex justify-center items-center space-x-2">
        <div class="bouncing-ball" [ngClass]="ballColor()"></div>
        <div
          class="bouncing-ball"
          [ngClass]="ballColor()"
          style="animation-delay: 0.1s"
        ></div>
        <div
          class="bouncing-ball"
          [ngClass]="ballColor()"
          style="animation-delay: 0.2s"
        ></div>
      </div>
      @if (message()) {
      <p class="mt-4 text-sm text-gray-500">{{ message() }}</p>
      }
    </div>
  `,
  styles: [
    `
      .bouncing-ball {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        animation: bounce 1.4s ease-in-out infinite both;
      }

      @keyframes bounce {
        0%,
        80%,
        100% {
          transform: scale(0);
        }
        40% {
          transform: scale(1);
        }
      }
    `,
  ],
})
export class BouncingLoaderComponent {
  message = input<string>('');
  ballColor = input<string>('bg-orange-500');
}
